import http from '../../utils/httpService';
import { FORGOT_PASSWORD_ROUTE } from './constants';

/**
 *
 * @param formData
 * @returns {*}
 */
const requestForgotPassword = (formData) => {
    const route = FORGOT_PASSWORD_ROUTE;
    return http.request(route, 'POST', formData);
};

export {
    requestForgotPassword
};

